import { FORTA_BLUE, FORTA_GRAY2 } from '../../utils/colors';

export const TREATMENT_PLAN_PAGE_CONTAINER_SX = {
  '::-webkit-scrollbar-thumb': {
    background: FORTA_BLUE.primary,
    borderColor: FORTA_GRAY2,
  },
  '::-webkit-scrollbar-track': {
    background: FORTA_GRAY2,
  },
};
